import { ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'
import SignupStudent, { FocusableElement } from '../../components/Auth/SignupStudent'
import { PageTitle } from '../../components/atoms'
import AuthPageLayout from '../../components/global/AuthPageLayout'
import { useIsMobileDevice } from '../../components/molecules/MobileDetectionWrapper/MobileDetectionWrapper'
import { PhoneBlockingDialog } from '../../components/molecules/PhoneBlockingDialog/PhoneBlockingDialog'

export const pageTitle = 'Sign Up - Create your password'
export const idCreatePasswordPageMainContent = 'create-password-page-main-content'

function SignUp (): ReactElement {
  const [searchParams] = useSearchParams()
  const isMobile = useIsMobileDevice()

  // Same detection as SignupStudent: the password-reset email lands here with a
  // `reset_password` query param. Reset is not a new-user flow and users with a pending
  // survey may legitimately be on a phone, so it is never gated.
  const isPasswordReset = searchParams.get('reset_password') !== null

  // The invitation email's "Verify me" link lands here. On a phone, block before the
  // password form so the T&Cs and post-login phone block are never reached (DMVP-1079).
  if (isMobile && !isPasswordReset) {
    return <PhoneBlockingDialog contactLinkId={FocusableElement.LinkContact} />
  }

  return (
    <AuthPageLayout mainId={idCreatePasswordPageMainContent}>
      <PageTitle title={pageTitle} />
      <section className='flex justify-center w-full md:w-auto'>
        <SignupStudent />
      </section>
    </AuthPageLayout>
  )
}

export default SignUp
